import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import { DefaultRateDetails } from '../../features/defaultRates/defaultRatesSlice';

export function fetchDefaultRateDetails(accommodationId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .get('/pricing/rates/getDefaultRateDetails', config)
    .then(res => res.data);
}

export function resetSearchResults() {
  return [];
}

export function addDefaultRate(defaultRateData: DefaultRateDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/pricing/rates/addDefaultRate', defaultRateData, config)
    .then(res => res.data);
}

export function updateDefaultRate(defaultRateData: DefaultRateDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put('/pricing/rates/updateDefaultRate', defaultRateData, config)
    .then(res => res.data);
}
